module.exports = __webpack_public_path__ + "img/14.cb3aad87.svg";